// extracted by mini-css-extract-plugin
export var formContainer = "pressReleasePage-module--formContainer--cb31f";
export var marketoForm = "pressReleasePage-module--marketoForm--d1780";
export var prBody = "pressReleasePage-module--prBody--bfc47";
export var prTitle = "pressReleasePage-module--prTitle--14983";
export var prWrapper = "pressReleasePage-module--prWrapper--cb8e4";